<template>
  <TagSelector
    :multiple="multiple"
    :items="filteredQbClasses"
    :value="value"
    @input="$emit('input', $event)"
    :placeholder="placeholder"
    :rules="rules"
  />
</template>

<script>
export default {
  props: {
    value: [String, Number, Array],
    multiple: Boolean,
    placeholder: String,
    rules: {
      type: Array,
      default: () => [],
    },
    selectedSkill: String,
    excludeIds: {
      type: Array,
      default: () => [],
    },
    excludeDeprecated: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      qbClasses: [],
    };
  },
  created() {
    this.setQbClasses();
  },
  computed: {
    filteredQbClasses() {
      let classes = this.qbClasses;
      if (this.excludeIds.length) {
        // Keeps only the classes whose IDs are NOT included in the excludeIds array
        classes = classes.filter((qbc) => !this.excludeIds.includes(qbc.id));
      }
      if (this.excludeDeprecated) {
        // Keep an already-selected deprecated class visible so existing selections don't disappear
        classes = classes.filter(
          (qbc) => !qbc.title.includes("(Deprecated)") || this.isSelected(qbc.id)
        );
      }
      return classes;
    },
  },
  methods: {
    isSelected(id) {
      return Array.isArray(this.value) ? this.value.includes(id) : this.value === id;
    },
    async setQbClasses() {
      const { data } = await this.$api.QbClass.lite();
      this.qbClasses = data;
    },
  },
  watch: {
    selectedSkill(newValue) {
      if (!newValue) return;
      const newQbClass = this.filteredQbClasses.find((qbc) =>
        qbc.skill_ids.includes(newValue)
      );
      if (newQbClass) this.$emit("input", newQbClass.id);
    },
  },
};
</script>

<style></style>
